import { Props_SnippetParagraph } from "./Paragraph.props";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import React from "react";

export const SnippetParagraph = (props: Props_SnippetParagraph) => {
  const { paragrpahProps, headingProps } = props;

  const titleClass = headingProps.visibility.value === 'visible' ? "snippet-paragraph__title" : "snippet-paragraph__title accessible-heading";

  return (
    <section className="snippet-paragraph">
      <div className="snippet-paragraph__container">
        {headingProps && <h2 className={titleClass}>{headingProps.heading.value}</h2>}
        {paragrpahProps && <div className="snippet-paragraph__text">{CompileMarkdown(paragrpahProps.text.value || "")}</div>}
      </div>
    </section>
  );
};
